var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadphones(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 7,
    fill: "url(#paint0_linear_197_662)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8 10C15.86 10 11 14.8358 11 20.7463V23.4328C11 25.9403 12.98 27.9104 15.5 27.9104C16.04 27.9104 16.4 27.5522 16.4 27.0149V19.8507C16.4 19.3134 16.04 18.9552 15.5 18.9552C14.51 18.9552 13.61 19.3134 12.89 19.8507C13.34 15.3731 17.21 11.791 21.8 11.791C26.39 11.791 30.26 15.2836 30.71 19.8507C29.99 19.3134 29.09 18.9552 28.1 18.9552C27.56 18.9552 27.2 19.3134 27.2 19.8507V27.0149C27.2 27.5522 27.56 27.9104 28.1 27.9104C28.64 27.9104 29.27 27.8209 29.72 27.5522C28.73 29.3433 27.2 30.7761 25.31 31.5821C25.13 30.5075 24.23 29.6119 23.06 29.6119C21.89 29.6119 20.9 30.597 20.9 31.7612C20.9 32.3881 21.17 33.0149 21.71 33.4627C22.16 33.8209 22.61 34 23.15 34C23.24 34 23.42 34 23.51 34C28.64 33.2836 32.6 28.7164 32.6 23.4328V20.7463C32.6 14.8358 27.74 10 21.8 10Z",
    fill: "url(#paint1_linear_197_662)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_197_662",
    x1: -5.90244,
    y1: -5.36585,
    x2: 44,
    y2: 48.8293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A31F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A31F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_197_662",
    x1: 10.55,
    y1: 9.55,
    x2: 31.7,
    y2: 33.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones);
export default __webpack_public_path__ + "static/media/headphones.4de34d9e447940678c95f0f5806f2a03.svg";
export { ForwardRef as ReactComponent };